import { render, staticRenderFns } from "./whitePaper.vue?vue&type=template&id=24467c3f&scoped=true"
import script from "./whitePaper.vue?vue&type=script&lang=js"
export * from "./whitePaper.vue?vue&type=script&lang=js"
import style0 from "./whitePaper.vue?vue&type=style&index=0&id=24467c3f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24467c3f",
  null
  
)

export default component.exports